/**
 * The 0700 day team (D-42, amended Oct 2026). Each table hands over to one of four
 * consultants, dealt from the session seed. The unfinished share of every remaining
 * patient counts as harm, weighted by colour and by how the consultant takes it.
 */
import type { Colour } from '../types.ts';

export interface DayConsultant {
  name: string;
  /** Said when the handover opens, so the table knows who it is talking to. */
  line: string;
  /** Multiplies the unfinished share before it counts as harm. */
  mult: number;
}

export const DAY_TEAM: DayConsultant[] = [
  { name: 'Dr Imelda Calm', line: 'Takes the list, says thank you, and has seen worse.', mult: 0.5 },
  { name: 'Dr Pradeep Fair', line: 'Asks one good question per patient and writes the answer down.', mult: 0.75 },
  { name: 'Dr Agatha Thorough', line: 'Wants the plan, the reason for the plan, and plan B.', mult: 1 },
  { name: 'Dr Rex Brusque', line: 'Arrives with a coffee and a frown: “Why is this one still here?”', mult: 1.5 },
];

/** How much an unfinished patient weighs at handover, by colour. */
export const HANDOVER_WEIGHT: Record<Colour, number> = { RED: 1, AMBER: 0.5, GREEN: 0.25 };
